export const invitedUserAuthorizationParams = {
  prompt: 'login' as const,
};

export const selfServeSignupAuthorizationParams = {
  screen_hint: 'signup' as const,
};
